<template>
  <div :class="classes">
    <img class="c-crop__img" :src="image" :style="imageStyles" />
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-crop",
  mixins: [contentComponent],
  computed: {
    image() {
      if (this.content.src.endsWith("/")) {
        return `${this.config.base}/${this.content.src}${this.screenWidth}${this.screenPrefix}.jpg`;
      } else {
        return `${this.config.base}/${this.content.src}`;
      }
    },
    screenPrefix() {
      return window.devicePixelRatio > 1.5 ? "-2x" : "";
    },
    screenWidth() {
      if (this.$vssWidth >= 1200) {
        return "1110";
      }
      if (this.$vssWidth >= 768) {
        return "930";
      }
      return "722";
    },
    imageStyles() {
      return {
        width: 100 * (100 / this.computeSize(this.size.width)) + "%",
        transform: `translate(-${this.computeSize(
          this.size.left
        )}%, -${this.computeSize(this.size.top, "y")}%)`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.c-crop {
  position: absolute;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  &--hotspot {
    cursor: pointer;
  }
  &--no-shadow {
    box-shadow: none;
  }
  &--bordered {
    border-radius: 0.25rem;
    border: 0.25rem solid #fff;
  }

  &__img {
    position: absolute;
    height: auto;
  }
}
</style>
